import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getProducts = async ({
  perPage = 500,
  customerType,
  customerId,
  pricingCategory,
  serviceType,
  productIds,
  serviceId,
}: JsonDataItem) => {
  const addCustomerType = customerType ? `&customer_type=${customerType}` : '';
  const addPricingCategory = pricingCategory ? `&default_category=${pricingCategory}` : '';
  const addCustomerId = customerId ? `&customerID=${customerId}` : '';
  const addServiceType = serviceType ? `&job_service_type=${serviceType}` : '';
  const addProductId = productIds?.length ? productIds.map((id: number) => `&product_id[]=${id}`).join('') : '';
  const addServiceId = serviceId ? `&service_id=${serviceId}` : '';

  const { data } = await baseQuery(
    `products?per_page=${perPage}${addCustomerType}${addCustomerId}${addPricingCategory}${addServiceType}${addProductId}${addServiceId}`,
  );

  return data;
};
